"use strict";
module.exports = {
    'name': 'Spanish',
    'code': 'es',
    'greeting': 'hola',
    'drag & drop': 'arrastrar y soltar',
    'or click here to browse': 'o clicca qui per navigare',
    'follow': 'Seguire',
    'following': 'Seguente',
    'explore tracks': 'Explorar pistas',
    'create your own': 'Crea tu propio',
};
